import React, { useMemo } from "react";
import { DlUnit } from "model/dl_unit/DlUnit";
import { useUnitUrlSearch } from "hooks/citajteo/dl_unit/useUnitSearch";
import UnitList from "./UnitList";
import styled from "styled-components";
import SearchNavigation from "components/navigation/search/SearchNavigation/SearchNavigation";
import { useUnitSearchOptionsFromUrl } from "hooks/citajteo/dl_unit/useUnitSearchOptionsFromUrl";
import {
  DL_UNIT_PER_PAGE_MAX,
  MAX_UNITS_EXCEL_EXPORT,
} from "constant/dl_unit/dl_unit.constant";
import { SEARCH_NAMES } from "constant/search/search";
import { useSearchParams } from "react-router-dom";
import {
  defaultUnitSearchValuesGet,
  exportUnitExcelFile,
} from "./UnitSearchList.logic";
import toast from "react-hot-toast";
import SearchUnitActivate from "../navigation/SearchUnitActivate/SearchUnitActivate";
import { UnitSearchParams } from "common/api/citajteo/dl_unit/citajteo_unit";

type UnitSearchListProps = {
  navigateToSearch?: boolean;
  isHM2?: boolean;
  includeHM2?: boolean;
  editMode?: boolean;
  showAdvancedSearch?: boolean;
  showAISearch?: boolean;
};

const UnitSearchList = ({
  navigateToSearch,
  isHM2,
  includeHM2,
  editMode,
  showAdvancedSearch,
  showAISearch,
}: UnitSearchListProps) => {
  const unitListResult = useUnitUrlSearch(isHM2, includeHM2);
  const unitSearchParams = useUnitSearchOptionsFromUrl();
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultSearchValues = useMemo<UnitSearchParams>(
    () => defaultUnitSearchValuesGet(unitSearchParams),
    [unitSearchParams],
  );

  const results: DlUnit[] = unitListResult ? unitListResult["items"] : [];

  const limit = +(unitSearchParams[SEARCH_NAMES.LIMIT] ?? DL_UNIT_PER_PAGE_MAX);
  const skip = +(unitSearchParams[SEARCH_NAMES.SKIP] ?? 0);
  const searchNavLiAct = (newSkip: number) => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(SEARCH_NAMES.SKIP, newSkip + "");
    setSearchParams(newSearchParams);
  };

  const exportHandle = async () => {
    // console.log("onExport");
    if (unitListResult?.resTotal) {
      if (unitListResult.resTotal <= MAX_UNITS_EXCEL_EXPORT) {
        await exportUnitExcelFile(
          { ...unitSearchParams, [SEARCH_NAMES.INCLUDE_HM2]: includeHM2 },
          "zapisi",
        );
        console.log("unitSearchParams", unitSearchParams);
      } else {
        toast.error(
          "Previše zapisa za eksport. Maksimum je " + MAX_UNITS_EXCEL_EXPORT,
        );
      }
    } else {
    }
  };

  return (
    <>
      <Div>
        <SearchUnitActivate
          searchLabel=""
          placeholder="Pretraživanje"
          navigateToSearch={navigateToSearch}
          defaultSearchValues={defaultSearchValues}
          showAdvancedSearch={showAdvancedSearch}
          showAISearch={showAISearch}
        />
        <SearchNavigation
          totalCount={unitListResult?.resTotal ?? 0}
          skip={skip}
          limit={limit}
          navAct={searchNavLiAct}
          showExport={editMode}
          onExport={exportHandle}
        />
      </Div>
      {results && results.length > 0 && (
        <UnitListDiv>
          <UnitList units={results} editMode={editMode} />
        </UnitListDiv>
      )}
    </>
  );
};

const Div = styled.div`
  margin-top: ${(props) => props.theme.spacing.l};
`;

const UnitListDiv = styled.div`
  margin-top: ${(props) => props.theme.spacing.l};
  margin-bottom: ${(props) => props.theme.spacing.l};
`;

export default UnitSearchList;
